import React, {useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { CustHealth_detail } from "../../Redux/actions/NumHealth";
import { Form, Radio, Button,DatePicker,Input} from "antd/lib";
import {CalendarOutlined } from "@ant-design/icons"
import Male from '../../images/boy-face.png'
import Female from '../../images/female-face.png'

export default function HStep1({ setCurrent, current }) {
//   console.log(current);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const CusDeatail = useSelector((state) => state?.healthdetail?.cusInfo);
  const [dob, setDob] = useState('');
  const [Age, setAge] = useState(CusDeatail?.Age ? CusDeatail?.Age + 'Years' : '');
  const [AgeInNum, setAgeInNum] = useState(CusDeatail?.Age ? CusDeatail?.Age : '');
  const [gvalue, setValue] = useState(CusDeatail?.gender ? CusDeatail?.gender : 'male');
  const [loading, setLoading] = useState(false);

  const calculateAge = (date) => {
    console.log(date)
    const dateString = moment(date).format('YYYY-MM-DD');
    console.log(dateString);
  
    setDob(dateString);
    const dobObject = new Date(date); // Convert the date string to a Date object
    console.log(dobObject)
    const ageDifMs = Date.now() - dobObject.getTime(); // Get the difference in milliseconds
    console.log(ageDifMs);
    
    const ageDate = new Date(ageDifMs); // Create a new date object using the difference
    console.log(ageDate);
    
    const ageInYears = Math.abs(ageDate.getUTCFullYear() - 1970).toString(); 
    console.log(ageInYears);
    if(ageInYears === '53') {
        setAge('')
        setAgeInNum('')
    } else {
        setAge(ageInYears +' '+ 'years')
        setAgeInNum(ageInYears)
    }
    console.log(Age)
};
const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
const disabledDate = (current) => {
  const today = moment();
  const minDate = today.subtract(18, 'years'); 

  return current.isAfter(minDate, 'day'); 
};
const getDefaultPickerValue = () => {
  const today = moment();
  const minDate = today.subtract(18, 'years');
  return minDate;
};       
const onChange = (e) => {
//   setRadioCheck(e.target.checked)
  console.log('radio checked', e.target.value);
  setValue(e.target.value);
};

  const OnFinish = (value) => {
    setLoading(true)
    const UpdateCus = {
        ...CusDeatail,
        name: value?.name,
        phonenumber: value?.phonenumber,
        gender: gvalue,
        dateofbirth : moment(value.dateofbirth).format('YYYY-MM-DD'),
        Age : AgeInNum
      }
    // value.initial = 'Self'
    dispatch(CustHealth_detail(UpdateCus))
    setTimeout(()=>{
      setLoading(false)
      setCurrent(current + 1);
    },1000)
  };
  return (
    <>
      <div className="step-container-health d-flex justify-content-center">
      <Form
            layout="vertical"
            form={form}
            style={{ width: "95%" }}
            requiredMark={false}
            onFinish={OnFinish}
            >
            <Form.Item>
              <Radio.Group 
                className='health-gender'
                onChange={onChange} 
                value={gvalue}>
                  <Radio.Button value='male'>
                    <span>
                       <img src={Male} className={` ${gvalue === 'male' ? 'remove-filter' : 'health-gender-img'}`}/>Male
                    </span>
                    </Radio.Button>
                  <Radio.Button value='female'>
                    <span>
                       <img src={Female} className={` ${gvalue === 'female' ? 'remove-filter' : 'health-gender-img'}`}/>Female
                    </span>
                  </Radio.Button>
              </Radio.Group>
            </Form.Item>
            <Form.Item 
            {...formItemLayout}
            label="Name"
            name='name'
            rules={[
                { pattern : /^[A-Za-z]+$/, message: 'Invalid Name, only letters are allowed',},
                {
                required: true, 
                message: 'please input name'
                }]}
                initialValue={CusDeatail?.name}
                >
            <Input 
            placeholder="Enter Name (eg. Harry)" />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
            label="Mobile Number"
            name='phonenumber'
            rules={[
                {
                    pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                    message: 'Invalid Mobile No',
                },
                { required: true, message: 'Enter Mobile No' },
                ]}
                initialValue={CusDeatail?.phonenumber}
            >
            <Input
                maxLength={10} 
                //addonBefore={prefixSelector}
                placeholder='Mobile NUmber'
            />
            </Form.Item>
            <Form.Item
            {...formItemLayout}
                label="Date of Birth"
                name='dateofbirth'
                rules={[
                {  
                    required: true,
                    message: 'please input DOB'
                },
                ]}
                initialValue={CusDeatail?.dateofbirth ? moment(CusDeatail?.dateofbirth) : null}
            >
            <DatePicker
            disabledDate={disabledDate}
            defaultPickerValue={getDefaultPickerValue()}
            style={{width: "100%",padding: "10px"}}
            suffixIcon={ Age ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '4px', color: '#0000ff94'}}>{Age}</span>
                    <CalendarOutlined />
                </div>
                ) : (
                <CalendarOutlined />
                )
            }
            format="YYYY-MM-DD"
            placeholder="YYYY-MM-DD"
            onChange={(date) => calculateAge(date)}
            />
            </Form.Item>
            <Form.Item >
              <div className='step-btn-health'>
              <Button 
              loading={loading}
              style={{width: "100%"}} 
              type="primary" htmlType="submit">
                Get Started
              </Button>
              </div>
            </Form.Item>
          </Form>
      </div>
    </>
  );
}
